const CHANNEL_COLLECTION = 'feeds';
const MAPPING_COLLECTION = 'feeds-mapping';

export const login = async (email, password, firebaseApp) => {
  return firebaseApp.auth().signInWithEmailAndPassword(email, password);
};

export const loginAnonymously = async (firebaseApp) => {
  return firebaseApp.auth().signInAnonymously();
};

export const logout = async (firebaseApp) => {
  return firebaseApp
    .auth()
    .signOut()
    .then(() => 'Success');
};

export const onAuthStateChanged = async (callback, firebaseApp) => {
  firebaseApp.auth().onAuthStateChanged(callback);
};

export const listenToChannel = async (
  channelId,
  onSnapshotCallback,
  firebaseApp
) => {
  return firebaseApp
    .firestore()
    .collection(CHANNEL_COLLECTION)
    .doc(channelId)
    .onSnapshot(onSnapshotCallback);
};

export const listenToChannelIds = async (onSnapshotCallback, firebaseApp) => {
  return firebaseApp
    .firestore()
    .collection(MAPPING_COLLECTION)
    .onSnapshot(onSnapshotCallback);
};
